// extracted by mini-css-extract-plugin
export default {"galleryWrapper":"Rjtkp","gallery":"rxjjZ","wrapperDots":"RgN_E"};